import { PracticeWithAdmin } from '@hb/shared'
import { createContext, useContext } from 'react'

export interface PracticeContextData {
  // practices?: LocalCollectionState<PracticeWithAdmin>
  practice: PracticeWithAdmin | null
  id: string | null
}
export const PracticeContext = createContext<PracticeContextData>({
  // practices: undefined,
  practice: null,
  id: null,
})

export const usePracticeContext = () => useContext(PracticeContext)
